/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field, FieldArray } from 'redux-form';
import './styles.less';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { KgIcon, MinuteIcon, PieceIcon, VolumeIcon } from '../../../../../components/text-icon';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { FormCheckboxField } from '../../../../../semantic-ui/components/form-checkbox-field';
import { CompatibilityComponent } from '../compatibility-component';
import AddButton from '../../../../../components/images/add-button.svg';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';

export const PlanningModalForm = ({
	modes,
	isModesLoading,
	configsOptions,
	isConfigsLoading,
	transportTypesOptions,
	isTransportTypeLoading,
	onCheckboxChange,
	onStartDateChange,
	onCreatedDateChange,
	formValues,
	onCompatibilityAdd,
	tariffTypesOptions,
	isTariffTypesLoading,
	autoparksOptions,
	isAutoparksLoading,
	onAllowWayChange,
}) => {
	return (
		<Grid className="planning-modal-form">
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Конфигурация планирования
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="config_id"
						type="text"
						component={FormSelectField}
						placeholder="Выберите конфигурацию планирования"
						options={configsOptions}
						loading={isConfigsLoading}
						disabled={isConfigsLoading}
						noResultsMessage="Конфигурация планирования не найдена"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>

			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Использовать автопарки
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field name="is_autopark" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			{!!formValues.is_autopark && (
				<>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Доступные автопарки
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8}>
							<Field
								name="autopark_ids"
								component={FormSelectField}
								placeholder="Выберите доступные автопарки"
								search
								multiple
								options={autoparksOptions}
								loading={isAutoparksLoading}
								disabled={isAutoparksLoading}
								noResultsMessage="Доступные автопарки не найдены"
								isWithoutSelectOnBlur
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Тариф автопарка
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8}>
							<Field
								name="tariff_type_id"
								component={FormSelectField}
								placeholder="Выберите тариф автопарка"
								search
								options={tariffTypesOptions}
								loading={isTariffTypesLoading}
								disabled={isTariffTypesLoading}
								noResultsMessage="Тарифы автопарка не найдены"
								isWithoutSelectOnBlur
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Коэффициент утилизации по массе
						</Grid.Column>
						<Grid.Column width={8} className="order-group-form__column">
							<Field
								name="weight_recycling_rate"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите коэффициент утилизации по массе"
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Коэффициент утилизации по объему
						</Grid.Column>
						<Grid.Column width={8} className="order-group-form__column">
							<Field
								name="volume_recycling_rate"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите коэффициент утилизации по объему"
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{!formValues.is_autopark && (
				<>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Тип транспорта
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8}>
							<Field
								name="transport_type_id"
								component={FormSelectField}
								placeholder="Выберите тип транспорта"
								search
								options={transportTypesOptions}
								loading={isTransportTypeLoading}
								disabled={isTransportTypeLoading}
								noResultsMessage="Тип транспорта не найден"
								isWithoutSelectOnBlur
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Кол-во доступного авто
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={8} className="order-group-form__column">
							<Field
								name="transport_count"
								type="text"
								normalize={normalizeInteger}
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите кол-во доступного авто"
								icon={PieceIcon}
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Грузоподъемность авто
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={4} className="order-group-form__column" style={{ maxWidth: 200 }}>
							<Field
								name="weight"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								icon={KgIcon}
								placeholder="Укажите массу"
							/>
						</Grid.Column>
						<div className="order-group-form__column utility-column">Коэфф. утилизации</div>
						<Grid.Column width={3} className="order-group-form__column">
							<Field
								name="weight_recycling_rate"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите коэфф."
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={6} className="order-group-form__column">
							Объем кузова авто
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={4} className="order-group-form__column" style={{ maxWidth: 200 }}>
							<Field
								name="volume"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								icon={VolumeIcon}
								placeholder="Укажите объем"
							/>
						</Grid.Column>
						<div className="order-group-form__column utility-column">Коэфф. утилизации</div>
						<Grid.Column width={3} className="order-group-form__column">
							<Field
								name="volume_recycling_rate"
								type="text"
								normalize={normalizeNumber}
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите коэфф."
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Коэффициент массы груза
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="weight_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите коэффициент массы груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Коэффициент объема груза
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="volume_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите коэффициент объема груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Максимальное кол. точек
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="points_amount"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={PieceIcon}
						placeholder="Укажите максимальное кол. точек"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Коэффициент скорости
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field
						name="speed_multiplier"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите коэффициент скорости"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Рабочая смена водителя
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<div className="planning-modal-form__time-fields">
						<div className="planning-modal-form__time-fields-wrapper">
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="work_time_from"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
							<span className="planning-modal-form__time-fields-separator">-</span>
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="work_time_to"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
						</div>
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Окно отгрузки
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<div className="planning-modal-form__time-fields">
						<div className="planning-modal-form__time-fields-wrapper">
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="pickup_time_from"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
							<span className="planning-modal-form__time-fields-separator">-</span>
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="pickup_time_to"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
						</div>
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Время отгрузки со склада
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="pickup_time"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={MinuteIcon}
						placeholder="Укажите время отгрузки со склада"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Окно доставки
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<div className="planning-modal-form__time-fields">
						<div className="planning-modal-form__time-fields-wrapper">
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="drop_time_from"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
							<span className="planning-modal-form__time-fields-separator">-</span>
							<div className="planning-modal-form__field planning-modal-form__field_with-time">
								<Field
									name="drop_time_to"
									type="time"
									component={FormInputField}
									autoComplete="off"
									placeholder="00:00"
								/>
							</div>
						</div>
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Время разгрузки у клиента
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="drop_time"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={MinuteIcon}
						placeholder="Укажите время разгрузки у клиента"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Совместимость температурных режимов
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field name="is_compatibility_mode" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			{formValues.is_compatibility_mode && (
				<>
					{formValues.compatibilities?.length === 0 && (
						<Grid.Row className="order-group-form__row">
							<Grid.Column width={14} className="order-group-form__column">
								Все температурные режимы совместимы между собой
							</Grid.Column>
						</Grid.Row>
					)}
					<FieldArray
						name="compatibilities"
						component={CompatibilityComponent}
						props={{
							modes,
							isModesLoading,
						}}
					/>
					<Grid.Row className="order-group-form__row">
						<Grid.Column width={14} className="order-group-form__column">
							<div className="order-group-form__button-row">
								<div className="order-group-form__button-row-text">
									Добавить группу совместимых температурных режимов
								</div>
								<img src={AddButton} alt="add-button" onClick={() => onCompatibilityAdd()} />
							</div>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Учесть километраж возврата на склад
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field name="is_refund" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Отгрузка в день доставки
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="is_pickup_day_to_day"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						onChange={value => onCheckboxChange('is_pickup_day_to_day', value)}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Гибкая дата доставки
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field
						name="is_flexible_date"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						onChange={value => onCheckboxChange('is_flexible_date', value)}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Одна отгрузка на одну машину
				</Grid.Column>
				<Grid.Column width={8} className="planning-modal-form__column">
					<Field name="is_ship_per_car" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Отгрузка в выходные дни
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field
						name="is_weekend_pickup"
						component={FormCheckboxField}
						disabled={formValues.is_pickup_day_to_day}
						toggle
						type="checkbox"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Доставка в выходные дни
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field
						name="is_weekend_drop"
						component={FormCheckboxField}
						disabled={!formValues.is_flexible_date}
						toggle
						type="checkbox"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="planning-modal-form__row">
				<Grid.Column width={6} className="planning-modal-form__column">
					Учесть маршруты Заказчика
				</Grid.Column>
				<Grid.Column width={1} className="planning-modal-form__column" style={{ alignContent: 'center' }}>
					<Field
						name="is_allow_way"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						onChange={value => onAllowWayChange(value)}
					/>
				</Grid.Column>
				{formValues.is_allow_way && (
					<Grid.Column width={5} className="order-group-form__column">
						<Field
							name="penalty_cost"
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите кол. нарушений маршрута"
						/>
					</Grid.Column>
				)}
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Учесть пробки
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field name="is_traffic_jams" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Учесть платные дороги
				</Grid.Column>
				<Grid.Column width={8} className="order-group-form__column">
					<Field name="is_toll_roads" component={FormCheckboxField} toggle type="checkbox" />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Маршрутизация от
				</Grid.Column>
				<Grid.Column width={1} className="order-group-form__column" style={{ alignContent: 'center' }}>
					<Field
						name="is_start_date"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						onChange={value => onStartDateChange(value)}
					/>
				</Grid.Column>
				{formValues.is_start_date && (
					<Grid.Column width={5} className="order-group-form__column">
						<Field
							name="start_date"
							nameField="start_date"
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							placeholder=". . / . . / . . . ."
							dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						/>
					</Grid.Column>
				)}
			</Grid.Row>
			<Grid.Row className="order-group-form__row">
				<Grid.Column width={6} className="order-group-form__column">
					Учесть дату создания заказа
				</Grid.Column>
				<Grid.Column width={1} className="order-group-form__column" style={{ alignContent: 'center' }}>
					<Field
						name="is_created_date"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						onChange={value => onCreatedDateChange(value)}
					/>
				</Grid.Column>
				{formValues.is_created_date && (
					<Grid.Column width={5} className="order-group-form__column">
						<Field
							name="build_days"
							type="text"
							normalize={normalizeInteger}
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите кол. дней на сборку"
						/>
					</Grid.Column>
				)}
			</Grid.Row>
		</Grid>
	);
};

PlanningModalForm.propTypes = {
	modes: PropTypes.array.isRequired,
	isModesLoading: PropTypes.bool,
	configsOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number,
			text: PropTypes.string,
			value: PropTypes.any,
		}),
	).isRequired,
	transportTypesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number,
			text: PropTypes.string,
			value: PropTypes.any,
		}),
	).isRequired,
	isConfigsLoading: PropTypes.bool,
	isTransportTypeLoading: PropTypes.bool,
	onCheckboxChange: PropTypes.func.isRequired,
	onStartDateChange: PropTypes.func.isRequired,
	onCreatedDateChange: PropTypes.func.isRequired,
	formValues: PropTypes.object.isRequired,
	onCompatibilityAdd: PropTypes.func.isRequired,
	autoparksOptions: PropTypes.array.isRequired,
	isAutoparksLoading: PropTypes.bool,
	tariffTypesOptions: PropTypes.array.isRequired,
	isTariffTypesLoading: PropTypes.bool,
	onAllowWayChange: PropTypes.func.isRequired,
};
